import { useRef, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { downloadFile } from "@/lib/download";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Factory, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const ProducedQtyMenu = ({ season }) => {
  const qc = useQueryClient();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const download = async () => {
    try { await downloadFile(`/products/produced-template.xlsx?season=${season}`, `quantita-prodotte-${season}.xlsx`); }
    catch { toast.error("Download non riuscito"); }
  };
  const upload = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/products/produced-import", fd);
      toast.success(`Quantità prodotte aggiornate per ${data.updated} capi${data.skipped.length ? ` · ${data.skipped.length} righe non riconosciute` : ""}`);
      qc.invalidateQueries({ queryKey: ["products"] });
      qc.invalidateQueries({ queryKey: ["analytics"] });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Importazione non riuscita");
    }
    setBusy(false);
  };
  return (
    <>
      <input ref={input} type="file" accept=".xlsx" className="hidden" onChange={upload} data-testid="produced-import-input" />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" disabled={busy} data-testid="produced-qty-btn">
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Factory className="mr-2 h-4 w-4" />}Quantità prodotte
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={download} data-testid="produced-download-item">Scarica Excel {season === "tutte" ? "(tutte le stagioni)" : season} da compilare</DropdownMenuItem>
          <DropdownMenuItem onClick={() => input.current?.click()} data-testid="produced-import-item">Importa Excel compilato</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
